import useTranslateMessage from '../../../../../../hooks/useTranslateMessage'
import { Box, Grid, Hidden, SvgIcon } from '@hermes/web-components'
import { RatePaperMobileTypography } from './styles'
import Treatment from '../Treatment'
import { StatisticTreatment } from '../../../../../../types'

const iconStyles = { width: '20px', height: '20px', color: 'system.navy900' }

type ProfileBadgesProps = {
  peerRecommendationsCount?: number
  yearsOfExperience?: number | null
  location?: string
  treatments: StatisticTreatment[]
  isPractice: boolean
}

const ProfileBadges = ({
  peerRecommendationsCount,
  yearsOfExperience,
  location,
  treatments,
  isPractice = false
}: ProfileBadgesProps) => {
  const translate = useTranslateMessage()

  return (
    <Grid container gap="12px">
      {!isPractice && !!peerRecommendationsCount && (
        <Grid component={Hidden} lgUp implementation="css" item container gap="12px" alignItems="flex-start">
          <Box display="flex" alignItems="flex-end">
            <SvgIcon sx={iconStyles} viewBox="0 0 20 20">
              <use href="#pen-icon" />
            </SvgIcon>
          </Box>
          <RatePaperMobileTypography>{`${peerRecommendationsCount} ${translate('search.peer_endorsements', {
            count: peerRecommendationsCount || 0
          })}`}</RatePaperMobileTypography>
        </Grid>
      )}
      {!!yearsOfExperience && !isPractice && (
        <Grid item container gap="12px" alignItems="flex-start">
          <Box display="flex" alignItems="flex-end">
            <SvgIcon sx={iconStyles}>
              <use href="#person-with-shield-icon" />
            </SvgIcon>
          </Box>
          <RatePaperMobileTypography>
            {translate('search.profileCard.badge.yearsOfExperience', {
              years: yearsOfExperience
            })}
          </RatePaperMobileTypography>
        </Grid>
      )}
      {!!location && (
        <Grid item container gap="12px" alignItems="flex-start">
          <Box display="flex" alignItems="flex-end">
            <SvgIcon stroke="currentColor" sx={iconStyles} viewBox="0 0 16 18">
              <use href="#location-pin-icon" />
            </SvgIcon>
          </Box>
          <RatePaperMobileTypography>{location}</RatePaperMobileTypography>
        </Grid>
      )}
      {!!treatments.length && (
        <Grid item container gap="8px" alignItems="center">
          {treatments.map((keyword) => (
            <Treatment key={keyword.label} {...keyword} />
          ))}
        </Grid>
      )}
    </Grid>
  )
}

export default ProfileBadges
